import { css } from '@emotion/react'
import { fonts } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const defaultColor = colors.n7.base

export const baseStyle = ({
  caps = false,
  color,
  fontSize,
}: {
  caps?: boolean
  color?: string
  fontSize?: number
}) =>
  css({
    color: color || defaultColor,
    fontFamily: fonts.sansSerif,
    fontSize: fontSize || 14,
    textTransform: caps ? 'uppercase' : 'none',
  })
